import type { ReactElement } from 'react';

/**
 * The inn, in miniature — a roof, a wall, a door. `currentColor` throughout
 * so it re-themes for free wherever it's dropped.
 */
export function BrandMark(): ReactElement {
  return (
    <span className="brand-mark" aria-hidden="true">
      <svg viewBox="0 0 32 32" fill="none">
        <path
          d="M5 16 L16 6 L27 16"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 15 V27 H24 V15"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinejoin="round"
        />
        <rect x="14" y="18" width="4" height="9" rx="1" fill="currentColor" />
      </svg>
    </span>
  );
}
